import "./ApplyNow.module.css";
import Header from "@/reusable_sections/Header";
import JoinTheNetwork from "./sections/JoinTheNetwork";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ApplyNowPage() {
  return <div>
      <Header />
      <JoinTheNetwork />
      <CommonQuestions />
      <Footer />
    </div>;
}